import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { dateToString, encodeBase64, handleGetCookie, checkPermissionByPath, displayUrl, convertStringToJson } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import { callExportAgent, callExportClameVehiclePDF } from "../../../api/export";
import { callCancelContract, callGetContractByKey, callgetVehicleCaseIdioms, cancelVehicleCaseIdioms, resetVehicleCaseIdioms } from "../../../api/contract/service";
import SmartTable from "../../../components/common/table-component";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import SwalAlert from "../../../components/common/alert";
import statusItems from "../../../data/statusCaseIdiomsContract"


import { CREATE, EDIT, PRINT, DELETE, CLAME } from "../../../utils/commonType"
import DatePicker from "react-datepicker";
import { callGetAllProvince } from "../../../api/settings/service";
import { DocumentPreviewUI, openDocumentPreview } from "../../../components/document-preview";
const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ startDate: '', endDate: '', status: '', id: '', page: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '' });
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);
	const location = useLocation();
	const [provinceList, setProvinceList] = useState([]);


	useEffect(() => {
		loadProvince()
		loadData();
	}, [location.state]);
	const columns = [
		{
			label: 'caseIdiomsCode', key: 'caseIdiomsCode', render: (val, item) => (
				<button
					className="btn btn-link"
					onClick={() =>
						downloadPDF(item?.id, 2)
					}
				>{val}</button>
			)
		},
		{
			label: 'caseIdiomsContractNumber', style: { minWidth: '20px' }, key: 'contractNo', render: (val) => (
				<button className="btn btn-link" onClick={() => openDetailClame(val)}>{val}</button>
			)
		},
		{ label: 'caseIdiomsAddress', style: { minWidth: '300px' }, key: 'address' },
		{
			label: 'caseIdiomsDocumentPath', style: { minWidth: '50px' }, key: 'documentPath', render: (val, item) => (
				item.documentPath && <DocumentPreviewUI documents={[...convertStringToJson(item.documentPath),...convertStringToJson(item.accidentImages)]} variant="cell" />
			)
		},
		{ label: 'caseIdiomsContactNumber', style: { width: '100px' }, key: 'contactNumber' },
		{ label: 'caseIdiomsThridPartyContactNumber', style: { width: '100px' }, key: 'thridPartyContactNumber' },
		{
			label: 'caseIdiomsThirdPartyLicensePlate', style: { width: '100px' }, key: 'thirdPartyLicensePlate',
			render: (val, item) => (
				item.thirdPartyVehicleModel + " / " + item.thirdPartyLicensePlate
			)
		},
		{
			label: 'caseIdiomsLicensePlate', style: { width: '100px' }, key: 'licensePlate',
			render: (val) => (val ? val : '-')
		},
		{
			label: 'caseIdiomsCarriredName', style: { minWidth: '150px' }, key: 'carriredName',
			render: (val) => (val ? val : '-')
		},
		{
			label: 'caseIdiomsPersonCase', style: { minWidth: '150px' }, key: 'personCase',
			render: (val) => (val ? val : '-')
		},


		{
			label: 'caseIdiomsStatus', key: 'status', render: (val) => (
				<span className={"badge " + (val === 1 ? "bg-success" : "bg-danger")}>{t('caseIdiomsStatus.' + val)}</span>
			)
		},
		{
			label: 'caseIdiomsCarriredDate', key: 'carriredDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
	];

	const loadData = async (e) => {
		// let body = { request }
		// if (e) {
		// 	setRequest((pre) => ({
		// 		...pre, ...e

		// 	}))
		// }
		let data = { ...request };
		if (e) {
			data = { ...data, ...e }
		}
		const rsp = await dispatch(callgetVehicleCaseIdioms(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)

		}

	}
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};
	const handleChangeProvince = (e) => {
		setRequest((prev) => ({ ...prev, provinceId: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(pathname + "/save/" + encodeBase64(id.id))
	}
	const handleClame = (id) => {
		navigate(pathname + "/clame/" + encodeBase64(JSON.stringify({ contractNumber: id.contractNo, caseIdiomsCode: id.caseIdiomsCode, ...id })))
	}
	const openDetailClame = (id) => {
		navigate(pathname + "/detail/" + encodeBase64(id))
	}

	const handleDelete = (item) => {
		SwalAlert.confirm(t("titleDelete"), t("confirmDelete"), async () => {
			try {
				const rsp = await dispatch(cancelVehicleCaseIdioms({ id: item.id, modifiedCode: userInfo?.data?.user?.userId, modifiedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName) }));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.successMSG(t("success.delete"));
					loadData();
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}
	const handleReset = (item) => {
		SwalAlert.confirm(t("titleReset"), t("confirmReset"), async () => {
			try {
				const rsp = await dispatch(resetVehicleCaseIdioms({ id: item.id, modifiedCode: userInfo?.data?.user?.userId, modifiedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName) }));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.successMSG(t("success.reset"));
					loadData();
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}
	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, reportType: 0, reportValue: null };
			let response = await callExportAgent(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `agent_${moment().format("YYYYMMDDHHmmss")}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};
	const downloadPDF = async (requestId, type) => {
		if (!requestId) return;

		try {

			const response = await callExportClameVehiclePDF({
				requestId,
				type,
				typeSql: 2
			});

			if (!response) {
				SwalAlert.error(
					__t("uiText.text035"),
					__t("uiText.text036")
				);
				return;
			}

			const url = URL.createObjectURL(response);
			const link = document.createElement("a");

			link.href = url;
			link.download = `clame_${moment().format(
				"YYYYMMDDHHmmss"
			)}.pdf`;

			document.body.appendChild(link);
			link.click();
			link.remove();

			URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Download PDF error:", error);

			SwalAlert.error(
				__t("uiText.text035"),
				__t("uiText.text037")
			);
		} finally {
		}
	};

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}


	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.contractControl.caseStatement")}</h4>

						<div className="group-button-header">
							{
								<PermissionWrapper permission={CREATE}>
									<button type="button" className="btn btn-primary" onClick={() => navigate(pathname + '/save')}>
										<i className="fas fa-plus"></i> {t("button.add")}
									</button>
								</PermissionWrapper>

							}

							{
								<PermissionWrapper permission={PRINT} >
									<button className="btn btn-success" onClick={downloadExcel}>
										<i className="fas fa-file-export"></i> {t("button.exportExcel")}
									</button>
								</PermissionWrapper>
							}

						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={request.startDate}
														onChange={date => setRequest((pre) => ({ ...pre, startDate: moment(date).format('YYYY-MM-DD') }))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={request.endDate}
														onChange={date => setRequest((pre) => ({ ...pre, endDate: moment(date).format('YYYY-MM-DD') }))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('search.keyword')}</label>
													<input
														type="text"
														name="keyword"
														className="form-control-uld"
														placeholder={t('search.keyword') + "..."}
														onChange={handleChange}
														value={request.keyword}
														autoComplete="off"
													/>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChangeProvince}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															statusItems.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>

												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData}
											actions={(item) => (
												<div style={{ minWidth: 150 }}>
													<PermissionWrapper permission={EDIT}>
														<button disabled={item.status != 1} className="btn btn-primary btn-sm" onClick={() => handleEdit(item)}>
															<i className="fas fa-pen"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={CLAME}>
														<button disabled={item.status != 1} className="btn btn-success btn-sm" onClick={() => handleClame(item)}>
															<i className="fas fa-hospital"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													{item.status != -1 && <PermissionWrapper permission={DELETE}>
														<button disabled={item.status != 1} className="btn btn-danger btn-sm" onClick={() => handleDelete(item)}>
															<i className="fas fa-trash"></i>
														</button>
													</PermissionWrapper>
													}
													{item.status == -1 && <PermissionWrapper permission={DELETE}>
														<button className="btn btn-danger btn-sm" onClick={() => handleReset(item)}>
															<i className="fas fa-reply"></i>
														</button>
													</PermissionWrapper>}
												</div>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
